"use client";

import { SectionFrame } from "@/components/ui/section-frame";
import { useScrollColumnReveal } from "@/hooks/use-scroll-column-reveal";

export function MathematicalSection() {
  const { ref, inView, leftRotate, rightRotate, opacity } = useScrollColumnReveal();

  return (
    <div data-testid="mathematical-section">
      <SectionFrame
        startColor="rgb(var(--accent-lime))"
        endColor="rgb(var(--accent-teal))"
        clipOverflowX={false}
        contentClassName="py-16"
      >
        {/* Observe the columns (not the SVG borders) so the reveal starts
            when the copy/art enter the trigger band — not off-screen. */}
        <div
          ref={ref}
          className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center"
          data-in-view={inView ? "true" : "false"}
        >
          {/* Left Column - Art: pivot bottom-right, swings in from left */}
          <div
            className="flex justify-center lg:justify-start order-2 lg:order-1 origin-bottom-right will-change-transform"
            data-testid="mathematical-art"
            style={{ transform: `rotate(${leftRotate}deg)`, opacity }}
          >
            <img
              src="/images/marketing/home/mathematical/balancing-art.webp"
              alt="Mathematical balancing illustration"
              className="w-full max-w-md lg:max-w-lg xl:max-w-xl"
            />
          </div>

          {/* Right Column - Icon and Text: pivot bottom-left, swings in from right */}
          <div
            className="flex flex-col items-start text-left order-1 lg:order-2 origin-bottom-left will-change-transform"
            data-testid="mathematical-copy"
            style={{ transform: `rotate(${rightRotate}deg)`, opacity }}
          >
            <img
              src="/images/marketing/home/mathematical/infinite-icon.svg"
              alt="Infinity icon"
              className="w-12 h-12 lg:w-16 lg:h-16 mb-4"
            />
            <h2 className="text-2xl md:text-3xl lg:text-4xl text-black mb-6">
              Deep Mathematical Thinking
            </h2>
            <p className="text-black/90 text-lg lg:text-xl/8 mb-6">
              Our games range from direct instruction on fractions to higher-level multi-step
              think-ahead problem-solving. We train minds, not fingers. Our platform is built for
              sustained deep mathematical thinking and learning, all while building math confidence
              and breaking the myth that some kids &quot;aren&apos;t math people.&quot;
            </p>
          </div>
        </div>
      </SectionFrame>
    </div>
  );
}

export default MathematicalSection;
